import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const lazyLoadImages = () => {
  console.log('Lazy loading images');
  // Placeholder: Implement actual lazy loading logic
  document.querySelectorAll('img[data-src]').forEach(img => {
    img.setAttribute('src', img.getAttribute('data-src') || '');
  });
};

export const initExitIntent = (id: string, delay: number, enabled: boolean) => {
  console.log(`Initializing exit intent: ${id}, ${delay}, ${enabled}`);
  // Placeholder: Implement actual exit intent logic
  if (enabled) {
    setTimeout(() => {
      const popup = document.getElementById(id);
      if (popup) popup.style.display = 'block';
    }, delay);
  }
};

// ADD THESE NEW FUNCTIONS:

// Improved ISO 8601 validation (accepts YYYY-MM-DD and full ISO format)
export const isValidISO8601 = (dateString: string): boolean => {
  const iso8601Regex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?$/;
  return iso8601Regex.test(dateString);
};

// Production-ready schema cleaning
export const cleanSchema = (schema: Record<string, unknown>) => {
  return JSON.stringify(schema, (key, value) => (value === undefined ? null : value));
};

// Simple URL validation
export const isValidUrl = (urlString: string): boolean => {
  try {
    new URL(urlString);
    return true;
  } catch {
    return false;
  }
};